import { render, staticRenderFns } from "./roleManagement.vue?vue&type=template&id=d013dbb6&scoped=true&"
import script from "./roleManagement.vue?vue&type=script&lang=js&"
export * from "./roleManagement.vue?vue&type=script&lang=js&"
import style0 from "./roleManagement.vue?vue&type=style&index=0&id=d013dbb6&lang=scss&scoped=true&"
import style1 from "./roleManagement.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d013dbb6",
  null
  
)

export default component.exports